import { render, staticRenderFns } from "./LayoutRow.vue?vue&type=template&id=10879587&scoped=true"
import script from "./LayoutRow.vue?vue&type=script&lang=js"
export * from "./LayoutRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@5.2.7_lodash@4.17.21_prettier@3.5.3_react@19.0.0_vue-template-c_l4y5rdbexcxjh5nqfbzyfvj2aq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10879587",
  null
  
)

export default component.exports